import { useQuery, useQueryClient } from 'react-query';

import { api } from '~/api';
import { captureException } from '~/utils/exception-tracking';

export const useUpdatePaymentMethod = () => {
  const queryClient = useQueryClient();

  const updatePaymentMethod = async (paymentMethodId) => {
    await api.paymentMethods.add(paymentMethodId);
    await Promise.all([
      queryClient.refetchQueries(['cart']),
      queryClient.refetchQueries(['card']),
    ]);
  };

  return { updatePaymentMethod };
};

/**
 * Fetch PaymentIntents for client_secret to complete stripe payment
 */
export const usePaymentIntents = (
  cartUuid,
  restrictedSkus,
  isLoadingCartValidation
) => {
  const enabledApiCall =
    Boolean(cartUuid) &&
    Boolean(!restrictedSkus?.length) &&
    Boolean(!isLoadingCartValidation);
  const {
    data: paymentIntent,
    isLoading,
    isError,
    ...rest
  } = useQuery(
    ['paymentIntents', cartUuid],
    () => api.paymentMethods.createPaymentIntent(cartUuid),
    {
      enabled: enabledApiCall,
      cacheTime: 0,
      onError: (error) =>
        captureException(new Error('PaymentIntent API error'), {
          extras: { error: error.message },
        }),
      retry: 3,
    }
  );

  return { paymentIntent, isLoading, isError, ...rest };
};

/**
 * Fetch payment data with a paymentMethodId
 */
export const usePaymentMethod = (paymentMethodId) => {
  const { data: paymentMethodData, isLoading } = useQuery(
    ['paymentMethod', paymentMethodId],
    () => api.paymentMethods.find(paymentMethodId),
    { enabled: Boolean(paymentMethodId) }
  );

  return { paymentMethodData, isLoading };
};
